var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSignatureTrue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4994_2476)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6666 2H3.33329C2.9651 2 2.66663 2.29848 2.66663 2.66667V6.77657C2.66663 11.6976 6.8494 13.5677 7.8065 13.9312C7.93331 13.9794 8.0666 13.9794 8.19342 13.9312C9.15052 13.5677 13.3333 11.6976 13.3333 6.77657V2.66667C13.3333 2.29848 13.0348 2 12.6666 2Z",
    fill: "#74C249"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 5.3335L7.11115 9.3335L5.33337 7.3335",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4994_2476"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignatureTrue);
export default __webpack_public_path__ + "static/media/signatureTrue.1eaacfcfa9bef38c18d84bd71fbcbe99.svg";
export { ForwardRef as ReactComponent };